export default "__VITE_ASSET__dd183639__"